/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Load_Project_File_Media_Import_Required_TitleInputs */

const en_load_project_file_media_import_required_title = /** @type {(inputs: Load_Project_File_Media_Import_Required_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Media Import Required`)
};

const fr_load_project_file_media_import_required_title = /** @type {(inputs: Load_Project_File_Media_Import_Required_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importation de media requise`)
};

const de_load_project_file_media_import_required_title = /** @type {(inputs: Load_Project_File_Media_Import_Required_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medienimport erforderlich`)
};

const it_load_project_file_media_import_required_title = /** @type {(inputs: Load_Project_File_Media_Import_Required_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importazione multimediale richiesta`)
};

const ru_load_project_file_media_import_required_title = /** @type {(inputs: Load_Project_File_Media_Import_Required_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Требуется импорт медиафайлов.`)
};

const es_load_project_file_media_import_required_title = /** @type {(inputs: Load_Project_File_Media_Import_Required_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se requiere importación de medios`)
};

const zh_cn2_load_project_file_media_import_required_title = /** @type {(inputs: Load_Project_File_Media_Import_Required_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`需要导入媒体文件`)
};

const ja_load_project_file_media_import_required_title = /** @type {(inputs: Load_Project_File_Media_Import_Required_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メディアのインポートが必要です`)
};

const hi_load_project_file_media_import_required_title = /** @type {(inputs: Load_Project_File_Media_Import_Required_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मीडिया आयात आवश्यक है`)
};

const pt_pt2_load_project_file_media_import_required_title = /** @type {(inputs: Load_Project_File_Media_Import_Required_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importação de mídia necessária`)
};

/**
* | output |
* | --- |
* | "Media Import Required" |
*
* @param {Load_Project_File_Media_Import_Required_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const load_project_file_media_import_required_title = /** @type {((inputs?: Load_Project_File_Media_Import_Required_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Load_Project_File_Media_Import_Required_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_load_project_file_media_import_required_title(inputs)
	if (locale === "de") return de_load_project_file_media_import_required_title(inputs)
	if (locale === "it") return it_load_project_file_media_import_required_title(inputs)
	if (locale === "ru") return ru_load_project_file_media_import_required_title(inputs)
	if (locale === "es") return es_load_project_file_media_import_required_title(inputs)
	if (locale === "zh-CN") return zh_cn2_load_project_file_media_import_required_title(inputs)
	if (locale === "ja") return ja_load_project_file_media_import_required_title(inputs)
	if (locale === "hi") return hi_load_project_file_media_import_required_title(inputs)
	if (locale === "pt-PT") return pt_pt2_load_project_file_media_import_required_title(inputs)
	return en_load_project_file_media_import_required_title(inputs)
});